// @flow
import gql from 'graphql-tag'

import { type Profile, PROFILE_FRAGMENT } from 'gql/profile'

export type RelatedSchoolListingsDataListings = {
  slug: string,
  name: string,
  imageUrl: string | null,
  location: {
    state: string,
    city: string,
  },
  profile: Profile,
  aggregateRatings: {
    count: Number,
    overall: number | null,
  } | null,
}

export type RelatedSchoolListingsData = {
  schoolListings: {
    listings: Array<RelatedSchoolListingsDataListings>,
  } | null,
}

export type RelatedSchoolListingsVariables = {
  location: {
    byCenter: {
      coords: {
        latitude: number,
        longitude: number,
      },
      radius: number,
    },
  },
}

export const RELATED_SCHOOL_LISTINGS_QUERY = gql`
  query RelatedSchoolListings(
    $location: SchoolListingsLocationInput!
    $excludeSchoolIds: [Int!]!
    $limit: Int!
  ) {
    schoolListings(location: $location, excludeSchoolIds: $excludeSchoolIds, limit: $limit) {
      listings {
        slug
        name
        imageUrl
        location {
          state
          city
        }
        profile {
          ...profile
        }
        aggregateRatings {
          count
          overall
        }
      }
    }
  }

  ${PROFILE_FRAGMENT}
`
